import Url from 'url-parse';

export default function pullQueryParam(name: string, from: string): string | undefined {
    const url = new Url(from, true);
    return url.query?.[name];
}
